module.exports = __webpack_public_path__ + "img/ecom-okey.21c29b61.png";